var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('van-skeleton',{staticStyle:{"padding-top":"15px","padding-bottom":"15px"},attrs:{"title":"","row":15}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }